export enum RecordingObjectType {
  DOC_WRITER_TOPIC = "doc-writer-topic",
  MODUS_CHAT = "modus-chat",
  OUTPUT_COMMENT = "output-comment",
  CHOOSE_MAIN_IDEA = "choose-main-idea"
}

export enum OutputGenerateReason {
  DESCRIBE_CHANGES = "describe-changes",
  DEFAULT = "default",
  MODUS = "modus",
  PURPOSE = "purpose",
  QUESTIONS = "questions",
  WRITING_STYLE = "writing-style",
  CHOOSE_MAIN_IDEA = "choose-main-idea"
}
